import { data } from "react-router-dom";
import { DELETE, GET, PATCH, POST, PUT, Upload } from "./controller.services";
import axios from '../api/axios';

// Notifications
export const deleteNotification = async (id) => DELETE(`/api/notifications/${id}/delete/`);
export const getAllNotifications = async (page, page_size) => GET(`/api/notifications/?page=${page}&page_size=${page_size}`);
export const markNotificationAsRead = async (id) => PATCH(`/api/notifications/${id}/mark_read/`, { is_read: true });
export const markAllNotificationAsRead = async () => POST(`/api/notifications/mark_all_read/`, { is_read: true });
export const createNotification = async ({ title, message, notification_type = 'warning', category = 'general', redirect_url = '' }) =>
  POST('/api/notifications/create/', { title, message, notification_type, category, redirect_url });



// ----------------Admin----------------
const buildDateParams = (data) => {
  let params = `campaign_id=${data.campaignId}`;
  
  // Only add period if no custom dates are provided
  if (data.startDate || data.endDate) {
    if (data.startDate) params += `&start_date=${data.startDate}`;
    if (data.endDate) params += `&end_date=${data.endDate}`;
  } else {
    params += `&period=${data.period}`;
  }
  
  return params;
};

export const adminDasbhoardStats = (data) => {
  return GET(`/api/calls/statistics/?${buildDateParams(data)}`);
}

export const adminDasbhoardLineChart = (data) => {
  return GET(`/api/calls/line-chart/?${buildDateParams(data)}&metric=${data.metric}`);
}

export const adminDasbhoardBarChart = (data) => {
  return GET(`/api/calls/analytics-bar-chart/?${buildDateParams(data)}&metric=${data.metric}`);
}

export const adminDasbhoardfunnelChart = (data) => {
  return GET(`/api/calls/funnel/?${buildDateParams(data)}`);
}

export const adminDasbhoardSuccessRateChart = (data) => {
  return GET(`/api/calls/conversion-pie-chart/?${buildDateParams(data)}`);
}

export const adminDashboardDispositionDistribution = (data) => {
  let url = `/api/calls/disposition-distribution/?${buildDateParams(data)}`;
  if (data.disposition != null) url += `&disposition=${encodeURIComponent(data.disposition)}`;
  return GET(url);
}

export const adminDasbhoardAgentPerformance = (data) => {
  let params = `campaign_id=${data.campaignId}`;
  
  // Only add local_filter if no custom dates are provided
  if (data.startDate || data.endDate) {
    if (data.startDate) params += `&start_date=${data.startDate}`;
    if (data.endDate) params += `&end_date=${data.endDate}`;
  } else {
    params += `&local_filter=${data.local_filter}`;
  }
  
  return GET(`/api/calls/agent-performance/?${params}`);
};

// Fallback endpoints for missing chart APIs
export const getCallsLineChart = (data) => {
  // Fallback to statistics if line-chart endpoint doesn't exist
  return GET("/api/calls/statistics/?period=" + data.period + "&campaign_id=" + data.campaignId);
};

export const getCallsBarChart = (data) => {
  // Fallback to statistics if bar-chart endpoint doesn't exist
  return GET("/api/calls/statistics/?period=" + data.period + "&campaign_id=" + data.campaignId);
};

export const getCallsFunnelChart = (data) => {
  // Fallback to statistics if funnel endpoint doesn't exist
  return GET("/api/calls/statistics/?period=" + data.period + "&campaign_id=" + data.campaignId);
};

export const getCallsSuccessRateChart = (data) => {
  // Fallback to statistics if conversion-pie-chart endpoint doesn't exist
  return GET("/api/calls/statistics/?period=" + data.period + "&campaign_id=" + data.campaignId);
};

export const getCallsAgentPerformance = (data) => {
  // Fallback to monthly stats if agent-performance endpoint doesn't exist
  return GET('/api/calls/agent-monthly-stats/');
};

// ----------------Admin-End----------------

export const loginApi = (data) => {
  return POST("/api/accounts/login/", data);
};

export const profileUpdateApi = (data) => {
  return PUT("/api/accounts/profile/", data);
};

export const profileApi = () => {
  return GET("/api/accounts/profile/");
};

export const changePasswordApi = (data) => {
  return POST("/api/accounts/change-password/", data);
};

export const logoutApi = () => {
  return POST("/api/accounts/logout/");
};

export const getCurrentUser = () => {
  return GET('/api/accounts/me/');
};

export const getOrgDetails = () => {
  return GET('/api/accounts/organizations/');
};

export const updateOrgDetails = (data) => {
  return PUT('/api/accounts/organization/update/', data);
};


export const getUsers = () => {
  return GET('/api/accounts/users/');
};

export const createUsers = (data) => {
  return POST('/api/accounts/users/', data);
};

export const updateUser = (data) => {
  return PUT(`/api/accounts/users/update/`, data);
};

export const updateActiveInactive = (data) => {
  return PATCH(`/api/accounts/users/update/`, data);
};

export const DeleteUser = (id) => {
  return DELETE(`/api/accounts/users/${id}/delete/`);
};

export const getCalls = (params = {}) => {
  return GET('/api/calls/', params);
};

export const getCallsHistory = (params = {}) => {
  const q = new URLSearchParams();
  q.set('page', params.page ?? 1);
  q.set('search', params.search || '');
  if (params.page_size) q.set('page_size', params.page_size);
  if (params.start_date) q.set('start_date', params.start_date);
  if (params.end_date) q.set('end_date', params.end_date);
  if (params.period) q.set('period', params.period);
  if (params.disposition) q.set('disposition', params.disposition);
  if (params.sub_disposition) q.set('sub_disposition', params.sub_disposition);
  if (params.campaign) q.set('campaign', params.campaign);
  if (params.direction) q.set('direction', params.direction);
  if (params.user_id) q.set('user_id', params.user_id);
  if (params.agent_ids) q.set('agent_ids', params.agent_ids);
  return GET(`/api/calls/agent-call-history/?${q.toString()}`);
};

export const exportCallsCSV = () => {
  return GET('/api/calls/export-csv/', { responseType: 'blob' });
};

export const getInboundCallReport = (params = {}) => {
  return GET('/api/calls/reports/inbound/', params);
};

export const getOutboundCallReport = (params = {}) => {
  return GET('/api/calls/reports/outbound/', params);
};

export const getCallDetails = (callId) => {
  return GET(`/api/calls/${callId}/details/`);
};
export const ingestCallLogs = (cdrPayload) => {
  return POST('/api/calls/ingest/', cdrPayload);
};

export const getMonthlyStats = () => {
  return GET('/api/calls/monthly-stats/');
};

export const getAgentMonthlyStats = () => {
  return GET('/api/calls/agent-monthly-stats/');
};
export const getAgentPerformance = () => {
  return GET('/api/calls/agent-performance/');
};

export const getCallConfigrationSetting = () => {
  return GET(`/api/calls/organization-telecom/get-config/`);
}
export const updateCallConfigrationSetting = (data) => {
  return PUT(`/api/calls/telecom/providers/update/`, data);
}
export const getCallSummary = (params) => {
  return GET('/api/calls/admin-summary/', params);
};

export const bulkDeleteCalls = (ids) => {
  return POST('/api/calls/admin-bulk-delete/', ids);
};


export const generateCampaignPublicKey = (campaignId) => POST('/api/campaigns/campaign/generate-public-key/', { campaign_id: campaignId });

export const getCampaigns = (data) => {
  const params = new URLSearchParams({ page: data.page });
  if (data.page_size) params.append('page_size', data.page_size);
  if (data.search) params.append('search', data.search);
  if (data.status !== undefined && data.status !== '') params.append('is_active', data.status);
  if (data.start_date) params.append('start_date', data.start_date);
  if (data.end_date) params.append('end_date', data.end_date);
  return GET(`/api/campaigns/campaign/?${params.toString()}`);
};

export const getCampaignById = (campaignId) => GET(`/api/campaigns/campaign/${campaignId}/`);

export const getCampaignsBasedOnUser = () => GET(`/api/campaigns/campaign/my-assigned-campaigns/`);

export const updateCampaignStatus = (campaignId, status, campaignData = null) => {
  const payload = campaignData
    ? { campaign_id: campaignId, ...campaignData }
    : { campaign_id: campaignId, is_active: status };
  return POST(`/api/campaigns/campaign/update-campaign/`, payload);
};


export const getCampaignGroupLeadsStatus = (data) => GET(`/api/campaigns/lead-groups/status/`);
export const getCampaignGroupLeads = (data) => {
  const params = new URLSearchParams();
  if (data.page) params.append('page', data.page);
  if (data.limit) params.append('page_size', data.limit);
  if (data.search) params.append('search', data.search);
  if (data.campaign) params.append('campaign', data.campaign);
  if (data.date) params.append('date', data.date);
  return GET(`/api/campaigns/lead-groups/?${params.toString()}`);
};
export const deleteCampaignGroupLead = (id, onlyUncalled = false) =>
  DELETE(`/api/campaigns/lead-groups/${id}/delete-leads/${onlyUncalled ? '?only_uncalled=true' : ''}`);
export const getCampaignGroupLeadDeleteSummary = (id) => GET(`/api/campaigns/lead-groups/${id}/delete-summary/`);
export const toggleCampaignGroupLeadPause = (id, isPaused) => POST(`/api/campaigns/lead-groups/${id}/pause/`, { is_paused: isPaused });
export const downloadCampaignGroupLeads = (id) => {
  const token = sessionStorage.getItem('access_token');
  return axios.get(`/api/campaigns/lead-groups/${id}/download/`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
};
export const getLeadBunchAnalytics = (id) => GET(`/api/campaigns/lead-groups/${id}/analytics/`);
export const bulkDeleteLeads = (data) => POST(`/api/campaigns/campaign/delete-bulk-leads/`, data);
export const resetExhaustedLeads = (data) => POST(`/api/campaigns/campaign/reset-exhausted-leads/`, data);

export const getAllLeads = (data) => {
  let url = `/api/campaigns/leads/?page=${data.page}&search=${data.search}&campaign=${data.campaign}&status=${data.status}&lead_group=${data.lead_group}&page_size=${data.limit}`;
  if (data.start_date) url += `&start_date=${data.start_date}`;
  if (data.end_date) url += `&end_date=${data.end_date}`;
  if (data.contact_status) url += `&contact_status=${data.contact_status}`;
  return GET(url);
};
export const getLeadsByCampaign = (campaignId) => GET(`/api/campaigns/${campaignId}/leads/`);

export const deleteCampaignLeads = (campaignId) => DELETE(`/api/campaigns/campaign/delete-campaign/?campaign=${campaignId}`);

export const uploadLeadsCSV = async (file) => {
  return Upload('/api/campaigns/upload/', file);
};

export const downloadLeads = async (campaignId) => {
  return GET(`/api/campaigns/${campaignId}/download/`, {
    responseType: 'blob'
  });
};

export const deleteLeads = async (campaignId) => {
  return DELETE(`/campaigns/${campaignId}/leads/`);
};
export const getLeadHistory = (leadId) => GET(`/api/campaigns/disposition-logs/?lead_id=${leadId}`);
export const getLeadHistoryByPhone = (phoneNumber) => GET(`/api/campaigns/disposition-logs/?phone_number=${encodeURIComponent(phoneNumber)}&page_size=50`);

export const getUpcomingCallbacks = () => GET('/api/campaigns/disposition-logs/upcoming-callbacks/');

// The signed-in agent's scheduled callbacks (overdue first) for the dashboard
// Priority Tasks queue. Unlike getUpcomingCallbacks — which is a 20-minute
// reminder window and hides overdue items — this includes overdue callbacks.
export const getMyCallbacks = (params = {}) => {
  const q = new URLSearchParams();
  if (params.limit) q.set('limit', params.limit);
  if (params.offset) q.set('offset', params.offset);
  const qs = q.toString();
  return GET(`/api/campaigns/disposition-logs/my-callbacks/${qs ? `?${qs}` : ''}`);
};

export const resolveLeadTimezone = async (phone, campaignId) => {
  const res = await GET(`/api/campaigns/resolve-timezone/?phone=${encodeURIComponent(phone)}&campaign_id=${campaignId}`);
  const data = res?.data || res;
  return {
    timezone: data.timezone,
    localTime: data.local_time,
    utcOffset: data.utc_offset,
  };
};

export const updateLeadStatus = async (leadId, status) => {
  return PATCH(`/campaigns/leads/${leadId}/`, { status });
};

export const getLOBTemplates = async () => {
  return GET('/api/campaigns/lob-templates/');
};

export const getLOBTemplateWithDispostionGroupByCampaignId = async (campaignId) => {
  return GET(`/api/campaigns/lob-template-with-dispostion-group/?campaign=${campaignId}`);
};
export const getDispositionsByCampaign = (campaignId) => GET(`/api/campaigns/campaign/${campaignId}/dispositions/`);


// Disposition Groups
export const getDispositionGroups = async () => {
  return GET('/api/campaigns/disposition-groups/');
};

export const createDispositionGroup = async (data) => {
  return POST('/api/campaigns/disposition-groups/', data);
};

export const updateDispositionGroup = async (id, data) => {
  return PUT(`/api/campaigns/disposition-groups/${id}/`, data);
};

export const deleteDispositionGroup = async (id) => {
  return DELETE(`/api/campaigns/disposition-groups/${id}/`);
};

// Dispositions
export const getDispositions = async (groupId = null) => {
  return GET(`/api/campaigns/dispositions/?group_id=${groupId}`)
};

export const getAllDispositions = async () => {
  // page_size=100 is the server's hard max (StandardPageNumberPagination) —
  // fine for filter dropdowns since orgs rarely configure 100+ dispositions,
  // but if that ever changes this needs a non-paginated list endpoint.
  return GET(`/api/campaigns/dispositions/?page_size=100&is_active=true`)
}

export const createDisposition = async (data) => {
  return POST('/api/campaigns/dispositions/', data);
};

export const updateDisposition = async (id, data) => {
  return PUT(`/api/campaigns/dispositions/${id}/`, data);
};

export const deleteDisposition = async (id) => {
  return DELETE(`/api/campaigns/dispositions/${id}/`);
};

export const toggleDispositionStatus = async (id) => {
  return POST(`/api/campaigns/dispositions/${id}/toggle-status/`);
};

// Subdispositions
export const getSubdispositions = async (dispositionId = null) => {
  return GET(`/api/campaigns/subdispositions/?disposition_id=${dispositionId}&page_size=100`)
};

export const createSubdisposition = async (data) => {
  return POST('/api/campaigns/subdispositions/', data);
};

export const updateSubdisposition = async (id, data) => {
  return PUT(`/api/campaigns/subdispositions/${id}/`, data);
};

export const deleteSubdisposition = async (id) => {
  return DELETE(`/api/campaigns/subdispositions/${id}/`);
};

export const toggleSubdispositionStatus = async (id) => {
  return POST(`/api/campaigns/subdispositions/${id}/toggle-status/`);
};

// Legacy endpoint - keep for backward compatibility

export const getDispositionTypes = async () => {
  return GET('/api/campaigns/dispositions/');
};

export const createDispositionType = async (data) => {
  return POST('/api/campaigns/dispositions/', data);
};

export const updateDispositionType = async (id, data) => {
  return PUT(`/api/campaigns/dispositions/${id}/`, data);
};

export const deleteDispositionType = async (id) => {
  return DELETE(`/api/campaigns/dispositions/${id}/`);
};

export const getLOBTemplateById = async (campaignId) => {
  return GET(`/api/campaigns/lob-templates/${campaignId}/`);
};

export const createCampaign = async (payload) => {
  return POST('/api/campaigns/campaign/', payload);
};

export const getOrganizations = () => {
  return GET('/api/accounts/organizations/');
};

export const getOrganizationsLegacy = async () => {
  return GET('/accounts/organizations/');
};
export const createOrganization = async (orgData) => {
  return POST('/api/accounts/organizations/', orgData);
};

export const startAsteriskForOrg = async (orgId) => {
  return POST(`/api/accounts/organizations/${orgId}/start-asterisk/`);
};

export const getAgents = async () => {
  return GET('/api/accounts/users/?role=agent');
};

export const getSupervisors = async () => {
  return GET('/api/accounts/users/?role=supervisor');
};

export const addTelecomConfig = async (data) => {
  return POST('/api/calls/organization-telecom/add-agent-config/', data);
}

export const getTelecomConfig = async (userId) => {
  return GET(`/api/calls/telecom/agents/${userId}/get-user`);
}

// export const createUser = async (userData) => {
//   return POST('/accounts/register/', userData);
// };

export const getAdminDashboardStats = async () => {
  return GET('/api/accounts/dashboard/');
};

export const getAgentDashboardStats = async (params = {}) => {
  const q = new URLSearchParams();
  if (params.period) q.set('period', params.period);
  if (params.start_date) q.set('start_date', params.start_date);
  if (params.end_date) q.set('end_date', params.end_date);
  const qs = q.toString();
  return GET(`/api/accounts/agent-dashboard/${qs ? `?${qs}` : ''}`);
};

// Agent Time Tracking APIs
export const updateAgentStatus = async (status) => {
  return POST('/api/accounts/agent-status/', { status });
};

export const getAgentTimeTracking = async () => {
  return GET('/api/accounts/agent-time-tracking/');
};

export const logAgentActivity = async (activityData) => {
  return POST('/api/accounts/agent-activity/', activityData);
};

// Agent Goals APIs
export const getAgentGoals = async () => {
  return GET('/api/accounts/agent-goals/');
};

// Admin: set/update goals for a specific agent
export const updateAgentGoalsForUser = (userId, goals) => {
  return PUT(`/api/accounts/admin/agent-goals/${userId}/`, goals);
};

// Admin: get goals for a specific agent (optionally for a specific date YYYY-MM-DD)
export const getAgentGoalsForUser = (userId, date) => {
  const params = date ? { date } : {};
  return GET(`/api/accounts/admin/agent-goals/${userId}/`, params);
};


export const getConversations = async () => {
  return GET('/api/whatsapp/conversations/');
};

export const getMessagesByConversation = async (conversationId) => {
  return GET(`/api/whatsapp/conversations/${conversationId}/messages/`);
};

export const sendWhatsAppMessage = async ({ phone, message, type = 'text' }) => {
  return POST('/api/whatsapp/send/', { phone, message, type });
};

export const getWhatsAppTemplates = async () => {
  return GET('/api/whatsapp/templates/');
};

export const createWhatsAppTemplate = async (data) => {
  return POST('/api/whatsapp/templates/', data);
};

export const deleteWhatsAppTemplate = async (id) => {
  return DELETE(`/api/whatsapp/templates/${id}/`);
};

export const getWhatsAppTemplate = async (id) => {
  return GET(`/api/whatsapp/templates/${id}/`);
};

export const submitTemplateToMeta = async (templateId) => {
  return POST(`/api/whatsapp/templates/${templateId}/submit/`);
};

export const checkWhatsAppTemplateStatus = async (templateId) => {
  return GET(`/api/whatsapp/templates/${templateId}/status/`);
};

export const sendWhatsAppTemplate = async (data) => {
  return POST('/api/whatsapp/templates/send/', data);
};

export const syncWhatsAppTemplates = async (department) => {
  return POST('/api/whatsapp/templates/sync/', { department: department || 'sales' });
};

export const bulkSendWhatsAppTemplate = async (data) => {
  return POST('/api/whatsapp/templates/bulk-send/', data);
};

// WhatsApp Conversation Flows
export const getWhatsAppFlows = async () => {
  return GET('/api/whatsapp/flows/');
};

export const createWhatsAppFlow = async (data) => {
  return POST('/api/whatsapp/flows/', data);
};

export const updateWhatsAppFlow = async (id, data) => {
  return PUT(`/api/whatsapp/flows/${id}/`, data);
};

export const deleteWhatsAppFlow = async (id) => {
  return DELETE(`/api/whatsapp/flows/${id}/`);
};

// WhatsApp Auto Responses
export const getWhatsAppAutoResponses = async () => {
  return GET('/api/whatsapp/auto-responses/');
};

export const createWhatsAppAutoResponse = async (data) => {
  return POST('/api/whatsapp/auto-responses/', data);
};

export const updateWhatsAppAutoResponse = async (id, data) => {
  return PUT(`/api/whatsapp/auto-responses/${id}/`, data);
};

export const deleteWhatsAppAutoResponse = async (id) => {
  return DELETE(`/api/whatsapp/auto-responses/${id}/`);
};

export const getWhatsAppStats = async (campaignId = null) => {
  const qs = campaignId && campaignId !== 'all' ? `?campaign_id=${campaignId}` : '';
  return GET(`/api/whatsapp/stats/${qs}`);
};

export const checkWhatsAppNumber = async (phone) => {
  return GET(`/api/whatsapp/check-number/?phone=${phone}`);
};

export const getOrCreateWhatsAppConversation = async (phone) => {
  return GET(`/api/whatsapp/get-or-create-conversation/?phone=${encodeURIComponent(phone)}`);
};

export const getWhatsAppConversations = async (campaignId = null) => {
  const qs = campaignId && campaignId !== 'all' ? `?campaign_id=${campaignId}` : '';
  return GET(`/api/whatsapp/conversations-list/${qs}`);
};

export const saveWhatsAppConfig = async (data) => {
  return PUT('/api/whatsapp/config/', data);
};
export const getWhatsAppConfig = async () => {
  return GET('/api/whatsapp/config/');
};

// Campaign-level WhatsApp config
export const getCampaignWhatsAppConfig = async (campaignId) => {
  return GET(`/api/campaigns/${campaignId}/whatsapp-config/`);
};
export const saveCampaignWhatsAppConfig = async (campaignId, data) => {
  return PUT(`/api/campaigns/${campaignId}/whatsapp-config/`, data);
};
export const deleteCampaignWhatsAppConfig = async (campaignId) => {
  return DELETE(`/api/campaigns/${campaignId}/whatsapp-config/`);
};
export const testWebhook = async (payload) => {
  return POST('/api/whatsapp/webhook/', payload);
};

// Campaign-scoped WhatsApp numbers (FEAT-002 backend)
export const syncWhatsAppNumbers = async () => {
  return POST('/api/whatsapp/numbers/sync/');
};
export const getWhatsAppNumbers = async () => {
  return GET('/api/whatsapp/numbers/');
};
export const tagWhatsAppNumberToCampaign = async (configId, campaignId) => {
  return POST(`/api/whatsapp/numbers/${configId}/campaign/`, { campaign_id: campaignId });
};
export const untagWhatsAppNumber = async (configId, campaignId) => {
  return DELETE(`/api/whatsapp/numbers/${configId}/campaign/`, { campaign_id: campaignId });
};
export const getCampaignWhatsAppNumber = async (campaignId) => {
  return GET(`/api/whatsapp/campaign-number/?campaign_id=${campaignId}`);
};
export const getWhatsAppHealth = async (campaignId = null) => {
  const qs = campaignId ? `?campaign_id=${campaignId}` : '';
  return GET(`/api/whatsapp/health/${qs}`);
};
export const getWhatsAppSetupStatus = async () => {
  return GET('/api/whatsapp/setup-status/');
};
export const testWhatsAppConnection = async (data) => {
  return POST('/api/whatsapp/test-connection/', data);
};

export const leadSummary = async (params = {}) => {
  return GET('/campaigns/leads/summary/', params);
}

export const getAssignedUsers = async (data) => {
  return GET(`/api/campaigns/org-users/?search=${data.search}&role=${data.role}&campaign_id=${data.campaign}`);
}
export const assignCampaignToUsers = (userIds, campaignId) => POST(`/api/campaigns/campaign/assign-users/`, { campaign_id: campaignId, users: userIds });

export const getTemplateDataByCampaignId = async (campaignId, excludeLeadId = null) => {
  const params = excludeLeadId ? `campaign=${campaignId}&exclude_lead_id=${excludeLeadId}` : `campaign=${campaignId}`;
  return GET(`/api/campaigns/lead-templates/next/?${params}`);
}

export const getLeadDataByLeadId = async (leadId) => {
  return GET(`api/campaigns/leads/get-by-id/?lead_id=${leadId}`);
}

export const submitLead = async (leadData) => {
  return POST(`/api/campaigns/leads/submit/`, leadData);
};
export const updateLeadByAdmin = async (leadData) => {
  return PATCH(`/api/campaigns/admin_leads/update/`, leadData);
};
export const createLeadByAdmin = async (leadData) => {
  return POST(`/api/campaigns/admin_leads/create/`, leadData);
};

export const auditTrail = async (data) => {
  let params = `user=${data.user_id || ''}&search=${data.search || ''}&limit=${data.limit}&page=${data.page}`;
  if (data.start_date) params += `&start_date=${data.start_date}`;
  if (data.end_date) params += `&end_date=${data.end_date}`;
  return GET(`/api/accounts/logs/?${params}`);
};

export const getAllUsersDispositionLogs = async (data) => {
  let params = `user=${data.user_id || ''}&search=${data.search || ''}&limit=${data.limit}&page=${data.page}`;
  if (data.start_date) params += `&start_date=${data.start_date}`;
  if (data.end_date) params += `&end_date=${data.end_date}`;
  if (data.campaign_id) params += `&campaign_id=${data.campaign_id}`;
  if (data.disposition) params += `&disposition=${data.disposition}`;
  if (data.source) params += `&source=${data.source}`;
  if (data.callback) params += `&callback=${data.callback}`;
  return GET(`/api/campaigns/all-disposition-logs/?${params}`);
};

export const downloadAllUsersDispositionLogs = async (data) => {
  let params = `user=${data.user_id || ''}&search=${data.search || ''}&limit=${data.limit}&page=${data.page}`;
  if (data.start_date) params += `&start_date=${data.start_date}`;
  if (data.end_date) params += `&end_date=${data.end_date}`;
  return GET(`/api/campaigns/download-all-disposition-logs/?${params}`, {
    responseType: 'blob'
  });
};

// Async export (Celery-backed, supports million+ rows)
export const startDispositionExport = async (data) => {
  return POST('/api/campaigns/v1/start-export/', data);
};

export const getExportStatus = async (taskId) => {
  return GET(`/api/campaigns/v1/export-status/?task_id=${taskId}`);
};

export const getExportDownloadUrl = (taskId) => {
  return `/api/campaigns/v1/export-download/?task_id=${taskId}`;
};


export const supervisorCallDetails = async (data) => {
  return GET(`/api/supervisor/call-details/?campaign_id=${data.campaign_id}&search=${data.search}&start_date=${data.start_date}&end_date=${end_date}&page=${data.page}`)
};


export const callAnalytics = async (data) => {
  let params = `campaign=${data.campaignId}&date_range=${data.dateRange}`;
  if (data.startDate) params += `&start_date=${data.startDate}`;
  if (data.endDate) params += `&end_date=${data.endDate}`;
  return GET(`/api/organization-stats/?${params}`);
}

export const callAnalyticsSalesStatus = async (data) => {
  let params = `campaign=${data.campaignId}&date_range=${data.dateRange}`;
  if (data.startDate) params += `&start_date=${data.startDate}`;
  if (data.endDate) params += `&end_date=${data.endDate}`;
  return GET(`/api/sales-dashboard-stats/?${params}`);
}

export const callAnalyticsGraph = async (data) => {
  let params = `campaign=${data.campaignId}&date_range=${data.dateRange}&date=${data.date}&page=${data.page}`;
  if (data.startDate) params += `&start_date=${data.startDate}`;
  if (data.endDate) params += `&end_date=${data.endDate}`;
  return GET(`/api/call-analytics/?${params}`);
}

// Companies
export const getCompanies = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/companies/companies/?${queryString}`);
};

export const getCompany = async (id) => {
  return GET(`/api/companies/companies/${id}/`);
};

export const createCompany = async (data) => {
  return POST('/api/companies/companies/', data);
};

export const updateCompany = async (id, data) => {
  return PUT(`/api/companies/companies/${id}/`, data);
};

export const deleteCompany = async (id) => {
  return DELETE(`/api/companies/companies/${id}/`);
};

export const getCompanyStats = async () => {
  return GET('/api/companies/companies/stats/');
};

// Customer 360° View
export const getCustomer360 = async (phone) => {
  return GET(`/api/campaigns/customer-360/?phone=${encodeURIComponent(phone)}`);
};

// Company Contacts
export const getCompanyContacts = async (companyId) => {
  return GET(`/api/companies/companies/${companyId}/contacts/`);
};

export const createCompanyContact = async (data) => {
  return POST('/api/companies/contacts/', data);
};

export const updateCompanyContact = async (id, data) => {
  return PUT(`/api/companies/contacts/${id}/`, data);
};

export const deleteCompanyContact = async (id) => {
  return DELETE(`/api/companies/contacts/${id}/`);
};

// Lead Analytics
export const getLeadAnalytics = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/campaigns/lead-analytics/?${queryString}`);
};

export const getLeadAnalyticsOverview = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/campaigns/lead-analytics/overview/?${queryString}`);
};

export const getLeadAnalyticsDetailed = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/campaigns/lead-analytics/detailed/?${queryString}`);
};

// Agent Groups
export const getAgentGroups = async () => {
  return GET('/api/campaigns/agent-groups/');
};

export const createAgentGroup = async (data) => {
  return POST('/api/campaigns/agent-groups/', data);
};

export const updateAgentGroup = async (id, data) => {
  return PUT(`/api/campaigns/agent-groups/${id}/`, data);
};

export const deleteAgentGroup = async (id) => {
  return DELETE(`/api/campaigns/agent-groups/${id}/`);
};

export const getAvailableAgents = async () => {
  return GET('/api/campaigns/agent-groups/available-agents/');
};

export const getAvailableSupervisors = async () => {
  return GET('/api/campaigns/agent-groups/available-supervisors/');
};

// Supervisor Agent Groups (Read-only)
export const getSupervisorAgentGroups = async () => {
  return GET('/api/campaigns/supervisor/agent-groups/');
};

export const getSupervisorAgentGroupStats = async (groupId) => {
  return GET(`/api/campaigns/supervisor/agent-groups/${groupId}/agents-stats/`);
};

// Supervisor Activities (Read-only)
export const getSupervisorActivities = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/campaigns/supervisor/activities/?${queryString}`);
};

export const getSupervisorDashboard = async () => {
  return GET('/api/campaigns/supervisor/dashboard/');
};

// Admin Activities (All users activity tracking)
export const getAdminActivities = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/accounts/admin/activity-logs/?${queryString}`);
};

// System Activities (Individual activity records)
export const getSystemActivities = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/accounts/admin/system-activities/?${queryString}`);
};

// ========== AGENT SESSION MANAGEMENT APIs ==========

// Agent Session APIs
export const agentLogin = async () => {
  return POST('/api/accounts/agent/login/');
};

export const agentLogout = async () => {
  return POST('/api/accounts/agent/logout/');
};

export const startBreak = async () => {
  return POST('/api/accounts/agent/break-start/');
};

export const endBreak = async () => {
  return POST('/api/accounts/agent/break-end/');
};

export const toggleTraining = async () => {
  return POST('/api/accounts/agent/training/');
};

export const getCurrentSession = async () => {
  return GET('/api/accounts/agent/current-session/');
};

export const agentEndShift = async () => {
  return POST('/api/accounts/agent/end-shift/');
};

// Shift Management APIs
export const getShifts = async () => {
  return GET('/api/accounts/shifts/');
};

export const createShift = async (data) => {
  return POST('/api/accounts/shifts/', data);
};

export const updateShift = async (id, data) => {
  return PUT(`/api/accounts/shifts/${id}/`, data);
};

export const deleteShift = async (id) => {
  return DELETE(`/api/accounts/shifts/${id}/`);
};

// Agent Profile APIs
export const getAgentProfile = async () => {
  return GET('/api/accounts/agent/profile/');
};

export const updateAgentProfile = async (data) => {
  return PUT('/api/accounts/agent/profile/', data);
};

// Agent Daily Summary APIs
export const getAgentDailySummary = async (date = null) => {
  const params = date ? `?date=${date}` : '';
  return GET(`/api/accounts/agent/daily-summary/${params}`);
};

export const getAgentSessionHistory = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/accounts/agent/session-history/?${queryString}`);
};

// Agent Profile Management
export const assignShiftToAgent = async (userId, shiftId) => {
  return POST('/api/accounts/agent-profiles/assign_shift/', {
    user_id: userId,
    shift_id: shiftId
  });
};

export const getAgentsWithShifts = async () => {
  return GET('/api/accounts/agent-profiles/agents_with_shifts/');
};

// Admin Session History API
export const getAdminSessionHistory = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`/api/accounts/admin/session-history/?${queryString}`);
};

// WhatsApp Configuration APIs
export const validateWhatsAppCredentials = async (data) => {
  return POST('/api/whatsapp/validate-credentials/', data);
};

// Test a SAVED number using its server-stored token (token never leaves IC/CRM).
export const testWhatsAppNumber = async (configId) => {
  return POST(`/api/whatsapp/numbers/${configId}/test/`);
};

export const whatsAppEmbeddedSignup = async (data) => {
  return POST('/api/whatsapp/embedded-signup/', data);
};

// NEW: Telecom Management APIs
export const getDirectTelecomProviders = () => GET('/api/calls/telecom/direct-providers/');
export const createDirectTelecomProvider = (data) => POST('/api/calls/telecom/direct-providers/', data);
export const getAsteriskServers = () => GET('/api/calls/telecom/asterisk-servers/');
export const updateAsteriskServer = (data) => POST('/api/calls/telecom/asterisk-servers/', data);
export const getTelecomStats = () => GET('/api/calls/telecom/stats/');

// SuperAdmin Review Management APIs
export const getReviews = (params = '') => GET(`/api/superadmin/reviews/${params}`);
export const getReviewStats = () => GET('/api/superadmin/reviews/stats/');
export const approveReview = (id) => POST(`/api/superadmin/reviews/${id}/approve/`);
export const rejectReview = (id) => POST(`/api/superadmin/reviews/${id}/reject/`);
export const toggleReviewFeatured = (id) => POST(`/api/superadmin/reviews/${id}/toggle_featured/`);
export const createReview = (data) => POST('/api/superadmin/reviews/', data);
export const updateReview = (id, data) => PUT(`/api/superadmin/reviews/${id}/`, data);
export const deleteReview = (id) => DELETE(`/api/superadmin/reviews/${id}/`);

// UPDATED: SuperAdmin Pricing Management APIs (use new billing system)
export const getPricingPlans = (params = '') => GET(`/api/billing/superadmin/plans/${params}`);
export const createPricingPlan = (data) => POST('/api/billing/superadmin/plans/', data);
export const updatePricingPlan = (id, data) => PUT(`/api/billing/superadmin/plans/${id}/`, data);
export const deletePricingPlan = (id) => DELETE(`/api/billing/superadmin/plans/${id}/`);
export const duplicatePlan = (id) => POST(`/api/billing/superadmin/plans/${id}/duplicate/`);

// Service management
export const getServiceModulesForPricing = () => GET('/api/billing/superadmin/services/');
export const createServiceModule = (data) => POST('/api/billing/superadmin/services/', data);
export const updateServiceModule = (id, data) => PUT(`/api/billing/superadmin/services/${id}/`, data);
export const deleteServiceModule = (id) => DELETE(`/api/billing/superadmin/services/${id}/`);

// Plan features are managed through plan.features JSON field in billing plans

// Billing Plans
export const getBillingPlans = () => GET('/api/billing/superadmin/plans/');
export const getBillingPlansEndpoint = '/api/billing/superadmin/plans/';

// Organization Services APIs
// Org-scoped enabled services (from the org's active subscriptions), NOT the
// full module catalog. Returns [{id, code, name, app, service_type, description}].
export const getOrganizationServices = (orgId) =>
  GET(`/api/billing/organizations/${orgId}/enabled-services/`);
export const getServiceModules = () => GET('/api/billing/service-modules/');
export const assignServicesToOrg = (data) => POST('/api/billing/subscriptions/create/', data);

// NEW BILLING SYSTEM ENDPOINTS

// SuperAdmin Billing Management (No Auth Required)
const API_BASE = import.meta.env?.VITE_API_URL ;

export const getSuperAdminServices = async () => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/services/`);
  return response.json();
};

// SuperAdmin Invoice Management
export const getSuperAdminInvoices = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${API_BASE}/api/billing/superadmin/invoices/?${query}`);
  return response.json();
};

export const downloadSuperAdminInvoice = async (invoiceId) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/invoices/${invoiceId}/download/`);
  return response;
};

export const exportSuperAdminInvoices = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${API_BASE}/api/billing/superadmin/invoices/export/?${query}`);
  return response;
};

export const createSuperAdminService = async (data) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/services/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return response.json();
};

export const updateSuperAdminService = async (id, data) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/services/${id}/`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return response.json();
};

export const deleteSuperAdminService = async (id) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/services/${id}/`, {
    method: 'DELETE'
  });
  return response.json();
};

export const getSuperAdminPlans = async () => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/plans/`);
  return response.json();
};

export const createSuperAdminPlan = async (data) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/plans/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return response.json();
};

export const updateSuperAdminPlan = async (id, data) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/plans/${id}/`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return response.json();
};

export const deleteSuperAdminPlan = async (id) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/plans/${id}/`, {
    method: 'DELETE'
  });
  return response.json();
};

export const duplicateSuperAdminPlan = async (id) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/plans/${id}/duplicate/`, {
    method: 'POST'
  });
  return response.json();
};

export const getPlansByService = async (serviceId) => {
  const response = await fetch(`${API_BASE}/api/billing/superadmin/plans/by_service/?service_id=${serviceId}`);
  return response.json();
};

// Admin Billing Management
export const getAdminSubscriptions = () => GET('/api/billing/subscriptions/');
export const upgradeSubscription = (id, planId) => POST(`/api/billing/subscriptions/${id}/update-plan/`, { billing_plan_id: planId });
export const cancelSubscription = (id) => POST(`/api/billing/subscriptions/${id}/cancel/`);
export const resetSubscriptionUsage = (id) => POST(`/api/billing/subscriptions/${id}/reset_usage/`);

export const getAdminPayments = () => GET('/api/billing/admin/payments/');
export const getAdminUsage = () => GET('/api/billing/admin/usage/');
export const getMonthlyUsageSummary = (month) => GET(`/api/billing/admin/usage/monthly_summary/?month=${month}`);

export const getAdminInvoices = () => GET('/api/billing/admin/invoices/');
export const downloadInvoicePDF = (id) => GET(`/api/billing/admin/invoices/${id}/download_pdf/`);

export const getAdminBillingAlerts = () => GET('/api/billing/admin/alerts/');
export const markAlertRead = (id) => POST(`/api/billing/admin/alerts/${id}/mark_read/`);
export const resolveAlert = (id) => POST(`/api/billing/admin/alerts/${id}/resolve/`);
export const markAllAlertsRead = () => POST('/api/billing/admin/alerts/mark_all_read/');

export const getAdminBillingDashboard = () => GET('/api/billing/admin/dashboard/');

// Organization Billing Dashboard
export const getOrganizationBillingDashboard = () => GET('/api/billing/admin/dashboard/');

// Available Plans for Organizations
export const getAvailableBillingPlans = () => GET('/api/billing/plans/');

// Payment Gateway Configuration
export const getPaymentGatewaySettings = () => GET('/api/billing/superadmin/payment-gateway/');
export const updatePaymentGatewaySettings = (data) => POST('/api/billing/superadmin/payment-gateway/update_settings/', data);

// Payment Processing
export const createPaymentOrder = (data) => POST('/api/billing/create_order/', data);
export const verifyPayment = (data) => POST('/api/billing/verify_payment/', data);

// Subscription Status
export const getSubscriptionStatus = () => GET('/api/billing/status/');

// LEGACY ENDPOINTS (DEPRECATED - Remove after migration)
// export const getBillingPlansEndpoint = '/api/accounts/billing-plans/';
// export const getOrganizationBilling = '/api/accounts/billing/';
// export const verifyPaymentEndpoint = '/api/payments/verify/';
// export const createPaymentOrder = '/api/payments/create-order/';

// ========== SUPPORT CRM APIs ==========

// Admin Tickets
export const getTickets = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/support/admin/tickets/?${query}`);
};

export const getTicket = (id) => GET(`/api/support/admin/tickets/${id}/`);
export const createTicket = (data) => POST('/api/support/admin/tickets/', data);
export const updateTicket = (id, data) => PATCH(`/api/support/admin/tickets/${id}/`, data);
export const deleteTicket = (id) => DELETE(`/api/support/admin/tickets/${id}/`);

// Agent ticket create — the admin endpoints above require IsTenantAdmin, so an
// agent must go through the IsAgent-scoped viewset instead (same serializer).
export const createAgentTicket = (data) => POST('/api/support/agent/my-tickets/', data);

// Ticket Threads
export const getTicketThreads = (ticketId) => GET(`/api/support/admin/ticket-threads/?ticket_id=${ticketId}`);
export const addTicketThread = (data) => POST('/api/support/admin/ticket-threads/', data);

// Knowledge Base
export const getKBArticles = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/support/admin/knowledge-base/?${query}`);
};

export const getKBArticle = (id) => GET(`/api/support/admin/knowledge-base/${id}/`);
export const createKBArticle = (data) => POST('/api/support/admin/knowledge-base/', data);
export const updateKBArticle = (id, data) => PUT(`/api/support/admin/knowledge-base/${id}/`, data);
export const deleteKBArticle = (id) => DELETE(`/api/support/admin/knowledge-base/${id}/`);

// Canned Responses
export const getCannedResponses = () => GET('/api/support/canned-responses/');
export const createCannedResponse = (data) => POST('/api/support/admin/canned-responses/', data);
export const updateCannedResponse = (id, data) => PUT(`/api/support/admin/canned-responses/${id}/`, data);
export const deleteCannedResponse = (id) => DELETE(`/api/support/admin/canned-responses/${id}/`);

// SLA Policies
export const getSLAPolicies = () => GET('/api/support/admin/sla-policies/');
export const createSLAPolicy = (data) => POST('/api/support/admin/sla-policies/', data);
export const updateSLAPolicy = (id, data) => PUT(`/api/support/admin/sla-policies/${id}/`, data);
export const deleteSLAPolicy = (id) => DELETE(`/api/support/admin/sla-policies/${id}/`);

// Chat Sessions
export const getChatSessions = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/support/admin/chat-sessions/?${query}`);
};
export const acceptChatSession = (id) => POST(`/api/support/admin/chat-sessions/${id}/accept/`);

// Agent APIs
export const getAgentTickets = () => GET('/api/support/agent/my-tickets/');
export const getAgentChats = () => GET('/api/support/agent/my-chats/');

// Support Dashboard Stats
export const getSupportDashboardStats = () => GET('/api/support/admin/tickets/dashboard_stats/');
export const getTeamMembers = () => GET('/api/accounts/users/');












// ================== Call API Start ==================
export const checkCallConfig = () => GET('/api/calls/call/check-config/');
export const getWebRTCSIPConfig = () => GET('/api/calls/call/webrtc-sip-config/');
export const getTeleCMIConfig = () => GET('/api/calls/call/telecmi-config/');
export const getActiveProviderType = () => GET('/api/calls/call/active-provider-type/');
export const initiateTeleCMIConference = (data) => POST('/api/calls/telecmi/conference/', data);
export const getCallStats = (data) => POST('/api/calls/call/initiate/', data);

// ================== ContactPad API ==================
export const getContactPadConfig = () => GET('/api/calls/contactpad/config/');
export const answerCall = (data) => POST('/api/calls/call/answer/', data);
export const rejectCall = (data) => POST('/api/calls/call/reject/', data);
export const hangupCall = (data) => POST('/api/calls/call/hangup/', data);
export const muteCall = (data) => POST('/api/calls/call/mute/', data);

export const forceLogoutUser = (userId) => POST(`/api/accounts/users/${userId}/force-logout/`);

// ================== CDR and CEL APIs ==================
export const getCDRData = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/calls/cdr/?${query}`);
};

export const getCDRStatistics = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/calls/cdr/statistics/?${query}`);
};

export const getCELData = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/calls/cel/?${query}`);
};

export const downloadCDRReport = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/calls/cdr/export/?${query}`, { responseType: 'blob' });
};

export const downloadCELReport = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/calls/cel/export/?${query}`, { responseType: 'blob' });
}; 


// ================== PBX Management APIs ==================
export const pbxListExtensions = () => GET('/api/calls/pbx/extensions/');
export const pbxCreateExtension = (data) => POST('/api/calls/pbx/extensions/create/', data);
export const pbxDeleteExtension = (ext) => DELETE(`/api/calls/pbx/extensions/${ext}/delete/`);
export const pbxResetPassword = (ext, data) => POST(`/api/calls/pbx/extensions/${ext}/reset-password/`, data);
export const pbxUpdateExtension = (ext, data) => PATCH(`/api/calls/pbx/extensions/${ext}/update/`, data);

export const pbxListQueues = () => GET('/api/calls/pbx/queues/');
export const pbxCreateQueue = (data) => POST('/api/calls/pbx/queues/create/', data);
export const pbxDeleteQueue = (name) => DELETE(`/api/calls/pbx/queues/${name}/delete/`);
export const pbxAddQueueMember = (name, data) => POST(`/api/calls/pbx/queues/${name}/members/add/`, data);
export const pbxRemoveQueueMember = (name, ext) => DELETE(`/api/calls/pbx/queues/${name}/members/${ext}/remove/`);

export const pbxListIVR = () => GET('/api/calls/pbx/ivr/');
export const pbxCreateIVR = (data) => POST('/api/calls/pbx/ivr/create/', data);
export const pbxUpdateIVR = (id, data) => PUT(`/api/calls/pbx/ivr/${id}/update/`, data);
export const pbxDeleteIVR = (id) => DELETE(`/api/calls/pbx/ivr/${id}/delete/`);
export const pbxUploadIVRAudio = (data) => POST('/api/calls/pbx/ivr/upload-audio/', data);

export const pbxListVoicemail = () => GET('/api/calls/pbx/voicemail/');
export const pbxListMOH = () => GET('/api/calls/pbx/moh/');
export const pbxUploadMOH = (data) => POST('/api/calls/pbx/moh/', data);
export const pbxDeleteMOH = (name) => DELETE(`/api/calls/pbx/moh/?name=${name}`);
export const pbxDeleteMOHFile = (name, fileId) => DELETE(`/api/calls/pbx/moh/?name=${name}&file_id=${fileId}`);

export const pbxListRoutingRules = () => GET('/api/calls/pbx/routing-rules/');
export const pbxCreateRoutingRule = (data) => POST('/api/calls/pbx/routing-rules/create/', data);
export const pbxUpdateRoutingRule = (id, data) => PUT(`/api/calls/pbx/routing-rules/${id}/update/`, data);
export const pbxDeleteRoutingRule = (id) => DELETE(`/api/calls/pbx/routing-rules/${id}/delete/`);

export const pbxGetSkills = () => GET('/api/calls/pbx/skills/');
export const pbxAssignSkill = (data) => POST('/api/calls/pbx/skills/', data);
export const pbxLiveStatus = () => GET('/api/calls/pbx/live-status/');

export const pbxGetAvailableUsers = () => GET('/api/calls/sip/users/available/');

// ================== SIM Trunk APIs ==================
export const pbxListTrunks = () => GET('/api/calls/pbx/trunks/');
export const pbxCreateTrunk = (data) => POST('/api/calls/pbx/trunks/create/', data);
export const pbxUpdateTrunkRouting = (id, data) => PUT(`/api/calls/pbx/trunks/${id}/routing/`, data);
export const pbxAssignCampaignToTrunk = (trunkId, campaignId, didNumber) => POST(`/api/calls/pbx/trunks/${trunkId}/assign-campaign/`, { campaign_id: campaignId, did_number: didNumber });
export const pbxDeleteTrunk = (id) => DELETE(`/api/calls/pbx/trunks/${id}/delete/`);
export const pbxSyncFromAsterisk = () => POST(`/api/calls/pbx/sync/`, {});

// ================== Pipeline Stages APIs ==================

// Pipeline Stages (admin config)
export const getPipelineStages = (campaignId) =>
  GET(`/api/campaigns/pipeline-stages/?campaign=${campaignId}`);

export const createPipelineStage = (data) =>
  POST('/api/campaigns/pipeline-stages/', data);

// PATCH, not PUT: a PUT sends the whole object, so any field the caller forgets
// to include gets reset to its model default. That silently re-activated
// deactivated stages and wiped role visibility. Partial updates are what the
// admin UI actually does, so PATCH matches the intent.
export const updatePipelineStage = (id, data) =>
  PATCH(`/api/campaigns/pipeline-stages/${id}/`, data);

export const deletePipelineStage = (id) =>
  DELETE(`/api/campaigns/pipeline-stages/${id}/`);

// Stage Transitions (admin config)
export const getStageTransitions = (campaignId) =>
  GET(`/api/campaigns/stage-transitions/?campaign=${campaignId}`);

export const createStageTransition = (data) =>
  POST('/api/campaigns/stage-transitions/', data);

export const updateStageTransition = (id, data) =>
  PATCH(`/api/campaigns/stage-transitions/${id}/`, data);

export const deleteStageTransition = (id) =>
  DELETE(`/api/campaigns/stage-transitions/${id}/`);

// Pipeline Bucket (supervisor/agent — leads assigned via stage transitions)
export const getPipelineBucketLeads = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return GET(`/api/campaigns/pipeline-bucket/?${query}`);
};

// My visible pipeline stages (for bucket filter pills)
export const getMyPipelineStages = () =>
  GET('/api/campaigns/pipeline-stages/my-stages/');

// Stage transitions for current lead context (used by SetDisposition)
export const getLeadStageTransitions = (campaignId, stageSlug) =>
  GET(`/api/campaigns/stage-transitions/?campaign=${campaignId}&from_stage_slug=${stageSlug || ''}`);

// Handoff targets — users in the target agent group for a stage
export const getHandoffTargets = (stageId) =>
  GET(`/api/campaigns/pipeline-stages/${stageId}/handoff-targets/`);

// Resolved disposition group for a pipeline stage (stage's own group, or campaign default)
export const getStageDispositions = (stageId) =>
  GET(`/api/campaigns/pipeline-stages/${stageId}/dispositions/`);

// Leads the current user handed to someone else, with outcome + conversion stats
export const getSentByMeLeads = (params) =>
  GET('/api/campaigns/pipeline-bucket/sent-by-me/', params);

// NOTE: there are no handoff/push-back service calls here on purpose.
// Both directions of a stage move ride the normal lead submit endpoint: the
// disposition carries the target person and appointment details, and the
// backend's transition engine applies the configured rule. A dedicated
// endpoint for either direction would be a second way to do the same thing.

// Appointments
export const rescheduleAppointment = (appointmentId, data) =>
  PATCH(`/api/campaigns/appointments/${appointmentId}/reschedule/`, data);

// Record what actually happened at the meeting (status + free-text outcome).
// Without this the no_show / completed / cancelled statuses on the model can
// never be set, which makes any report built on them permanently empty.
export const updateAppointment = (appointmentId, data) =>
  PATCH(`/api/campaigns/appointments/${appointmentId}/`, data);


// Record what actually happened at a meeting — and, optionally, the resulting
// lead outcome — without going through the calling screen.
//
// This is the route that lets someone whose contribution was attending a
// meeting mark the lead converted/dropped. Previously the only way to set a
// lead outcome was submitting a disposition from the dialler, so a supervisor
// who only ran an interview had to log a call that never happened.
export const recordAppointmentOutcome = (appointmentId, data) =>
  POST(`/api/campaigns/appointments/${appointmentId}/record-outcome/`, data);

// Meetings that still need to happen.
//   scope:  'mine' (default) | 'team'  — 'team' is supervisor/admin only
//   window: 'all' (default) | 'today' | 'week' | 'overdue'
// Response payload: { results: [...], counts: { open, overdue, today, week } }
export const getUpcomingAppointments = (params = {}) =>
  GET('/api/campaigns/appointments/upcoming/', params);

// ================== Google Calendar / Meet Integration ==================
// Admin-only connect flow: getGoogleCalendarConnectUrl returns a Google OAuth
// consent URL (the frontend navigates the browser to it directly — this is a
// full-page redirect flow, not a popup, since Google's callback lands back
// on our own backend, not inside a JS message listener like the WhatsApp/Meta
// embedded flows). getGoogleCalendarStatus/disconnect manage the connection
// once it exists.
export const getGoogleCalendarConnectUrl = () => GET('/api/google-calendar/connect/');
export const getGoogleCalendarStatus = () => GET('/api/google-calendar/status/');
export const disconnectGoogleCalendar = () => POST('/api/google-calendar/disconnect/');
